import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Table, Typography } from 'antd';
import { expensesColumns } from '../../../utils/table-config/ExpensesTableConfig';

const { Text } = Typography;

// Custom styles for the expenses table
const tableStyles = `
    // .grand-total-row {
	// 	background-color: #f0f8ff !important;
	// 	font-weight: 700 !important;
	// }
	// .grand-total-row td {
	// 	border-top: 2px solid #1890ff !important;
	// }
	.expenses-table-wrapper .ant-table-thead > tr > th {
		background-color: #fafafa !important;
		font-weight: 600 !important;
		color: #333 !important;
	}
`;

const toMoney = (n) => `₹ ${(Number(n) || 0).toLocaleString('en-IN')}`;
const lineCost = (rate, qty) => (Number(rate) || 0) * (Number(qty) || 0);

const PER_ORDER_COLUMNS = [
	{ title: 'Rate ID', dataIndex: 'rate_id', key: 'rate_id' },
	{
		title: 'Vendor Rate',
		dataIndex: 'vendor_rate',
		key: 'vendor_rate',
		render: (v) => (v == null || v === '' ? '-' : `₹ ${v}`),
	},
	{ title: 'Quantity', dataIndex: 'quantity', key: 'quantity', render: (v) => v ?? 0 },
	{
		title: 'Vendor Cost',
		key: 'vendor_cost',
		render: (_, r) => toMoney(lineCost(r.vendor_rate, r.quantity)),
	},
];

function ExpensesTab({ tripDetails, tripId, expensesData, expensesLoading, perOrderRates }) {
	// Filter out GRAND TOTAL row from expenses data
	const filteredExpensesData =
		expensesData?.filter((record) => record.particular !== 'GRAND TOTAL') || [];
	const hasPerOrderRates = Array.isArray(perOrderRates) && perOrderRates.length > 0;
	const perOrderTotals = (perOrderRates || []).reduce(
		(acc, r) => ({
			vendor: acc.vendor + lineCost(r.vendor_rate, r.quantity),
		}),
		{ vendor: 0 }
	);

	return (
		<>
			<style>{tableStyles}</style>
			{/* Trip Details Section */}
			<div style={{ marginBottom: 32 }}>
				<div
					style={{
						fontSize: 18,
						fontWeight: 600,
						color: '#1890ff',
						marginBottom: 16,
					}}
				>
					Trip ID: {tripId}
				</div>
				<div
					style={{
						display: 'grid',
						gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
						gap: 16,
						padding: 16,
						backgroundColor: '#fafafa',
						borderRadius: 8,
						border: '1px solid #e8e8e8',
					}}
				>
					<div>
						<div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Client:</div>
						<div style={{ fontSize: 14, fontWeight: 500, color: '#333' }}>
							{tripDetails?.client || '-'}
						</div>
					</div>
					<div>
						<div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Project:</div>
						<div style={{ fontSize: 14, fontWeight: 500, color: '#333' }}>
							{tripDetails?.project || '-'}
						</div>
					</div>
					<div>
						<div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Vendor:</div>
						<div style={{ fontSize: 14, fontWeight: 500, color: '#333' }}>
							{tripDetails?.vendor || '-'}
						</div>
					</div>
					<div>
						<div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
							Trip Type:
						</div>
						<div style={{ fontSize: 14, fontWeight: 500, color: '#333' }}>
							{tripDetails?.tripType || '-'}
						</div>
					</div>
					<div>
						<div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
							Source Location*:
						</div>
						<div style={{ fontSize: 14, fontWeight: 500, color: '#333' }}>
							{tripDetails?.sourceLocation || '-'}
						</div>
					</div>
					<div>
						<div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
							Destination Location*:
						</div>
						<div style={{ fontSize: 14, fontWeight: 500, color: '#333' }}>
							{tripDetails?.destinationLocation || '-'}
						</div>
					</div>
				</div>
			</div>

			{/* Margin Statement Section */}
			<div style={{ marginBottom: 24 }}>
				<div
					style={{
						fontSize: 16,
						fontWeight: 700,
						color: '#333',
						marginBottom: 16,
					}}
				>
					Margin Statement
				</div>
				{expensesLoading && <Spin tip="Loading expenses..." />}
				{!expensesLoading && (
					<div className="expenses-table-wrapper">
						<Table
							// dataSource={expensesData}
							dataSource={filteredExpensesData}
							columns={expensesColumns}
							rowKey="id"
							pagination={false}
							scroll={{ x: 700 }}
							bordered
							size="small"
							style={{
								border: '1px solid #d9d9d9',
								borderRadius: '6px',
							}}
							// rowClassName={(record) =>
							// 	record.particular === 'GRAND TOTAL' ? 'grand-total-row' : ''
							// }
							locale={{
								emptyText: (
									<div style={{ padding: '40px 0', textAlign: 'center' }}>
										<Text type="secondary" style={{ fontSize: 16 }}>
											No margin statement data found for this trip.
										</Text>
									</div>
								),
							}}
						/>
					</div>
				)}
			</div>
			{hasPerOrderRates && (
				<div style={{ marginBottom: 24 }}>
					<div
						style={{
							fontSize: 16,
							fontWeight: 700,
							color: '#333',
							marginBottom: 16,
						}}
					>
						Per Order Rates
					</div>
					<div className="expenses-table-wrapper">
						<Table
							dataSource={perOrderRates}
							columns={PER_ORDER_COLUMNS}
							rowKey="rate_id"
							pagination={false}
							scroll={{ x: 800 }}
							bordered
							size="small"
							style={{ border: '1px solid #d9d9d9', borderRadius: '6px' }}
							// eslint-disable-next-line react/no-unstable-nested-components
							summary={() => (
								<Table.Summary.Row>
									<Table.Summary.Cell index={0} colSpan={3}>
										<Text strong>TOTAL</Text>
									</Table.Summary.Cell>
									<Table.Summary.Cell index={3}>
										<Text strong>{toMoney(perOrderTotals.vendor)}</Text>
									</Table.Summary.Cell>
								</Table.Summary.Row>
							)}
						/>
					</div>
				</div>
			)}
		</>
	);
}

ExpensesTab.propTypes = {
	tripDetails: PropTypes.shape({
		client: PropTypes.string,
		project: PropTypes.string,
		vendor: PropTypes.string,
		tripType: PropTypes.string,
		sourceLocation: PropTypes.string,
		destinationLocation: PropTypes.string,
	}),
	tripId: PropTypes.string,
	expensesData: PropTypes.array,
	expensesLoading: PropTypes.bool,
	perOrderRates: PropTypes.arrayOf(
		PropTypes.shape({
			rate_id: PropTypes.string,
			client_rate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			vendor_rate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		})
	),
};

export default ExpensesTab;
